module.exports = __webpack_public_path__ + "static/young-leader-photo-anupama_santhosh-b04130c58eef8edeab7866f9809e4aac.jpg";